/**
 * A one-shot "open the Fill specs review screen when Inventory next mounts".
 *
 * The review modal lives inside Inventory.jsx, so the banner can open it with
 * an `open-enrich-specs` event only when Inventory is already on screen. From
 * the dashboard there is nothing listening yet: the navigate event has to
 * mount the Inventory tab first, and its chunk is lazy, so there is no delay
 * that is both short enough to feel immediate and long enough to be safe on a
 * slow connection.
 *
 * A flag the mounting component consumes has no race to lose. It is
 * deliberately not state or context — nothing re-renders on it, and it is read
 * exactly once.
 */

let pending = false;

/** Ask for the review screen to open as soon as Inventory is available. */
export function requestEnrich() {
    pending = true;
}

/** Read and clear the request. Returns true at most once per call to request. */
export function consumeEnrich() {
    const was = pending;
    pending = false;
    return was;
}
